import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  NgArrayPipesModule,
  NgStringPipesModule,
  NgNewlinesPipeModule
} from 'angular-pipes';

import { GoBackDirective } from './directives/go-back.directive';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { LocalizedNumberPipe } from './pipes/localized-number.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { KeysPipe } from './pipes/keys.pipe';
import { IsEmptyPipe } from './pipes/is-empty.pipe';
import { SerialPipe } from './pipes/serial.pipe';
import { LinkifyPipe } from './pipes/linkify.pipe';
import { HasEmptyValuesPipe } from './pipes/has-empty-values.pipe';
import { ImageFromApiPipe } from './pipes/image-from-api.pipe';

import { ExpandableListComponent } from './components/expandable-list/expandable-list.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { ListValuesComponent } from './components/list-values/list-values.component';
import { FormAutocompleteComponent } from './components/form-autocomplete/form-autocomplete.component';
import { FormNumberComponent } from './components/form-number/form-number.component';
import { TagEditorComponent } from './components/tag-editor/tag-editor.component';
import { FileService } from './services/file.service';
import { UrlParamsService } from './services/url-params.service';
import { UploaderComponent } from './components/uploader/uploader.component';
import { UploaderErrorsDirective } from './components/uploader/directives/uploader-errors.directive';
import { UploaderLoadingDirective } from './components/uploader/directives/uploader-loading.directive';
import { LoadingComponent } from './components/loading/loading.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FileSizePipe } from './pipes/file-size';
import { UploaderHeaderDirective } from './components/uploader/directives/uploader-header.directive';
import { MultiImagesPickerComponent } from './components/multi-images-picker/multi-images-picker.component';
import { PickerChoiceDirective } from './components/multi-images-picker/directives/picker-choice.directive';
import { PickerDialogComponent } from './components/multi-images-picker/picker-dialog/picker-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PortalModule } from '@angular/cdk/portal';
import { PickerButtonDirective } from './components/multi-images-picker/directives/picker-button.directive';
import {
  ImagesSelectableListComponent
} from './components/multi-images-selectable-list/images-selectable-list.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { UploaderPlaceholderDirective } from './components/uploader/directives/uploader-placeholder.directive';
import {
  DecoratedUploaderComponent
} from './components/multi-images-selectable-list/decorated-uploader/decorated-uploader.component';
import { TruncNumberPipe } from "./pipes/trunc-number";

const common = {
  modules: [
    CommonModule,
    FormsModule,
    PortalModule,
    MatGridListModule
  ],
  components: [
    ExpandableListComponent,
    TooltipComponent,
    ListValuesComponent,
    FormAutocompleteComponent,
    FormNumberComponent,
    TagEditorComponent,
    UploaderComponent,
    PickerChoiceDirective,
    PickerButtonDirective,
    UploaderErrorsDirective,
    UploaderLoadingDirective,
    UploaderHeaderDirective,
    UploaderPlaceholderDirective,
    MultiImagesPickerComponent
  ],
  pipes: [
    CapitalizePipe,
    LocalizedDatePipe,
    LocalizedNumberPipe,
    TimeAgoPipe,
    KeysPipe,
    IsEmptyPipe,
    LinkifyPipe,
    SerialPipe,
    HasEmptyValuesPipe,
    ImageFromApiPipe,
    FileSizePipe,
    TruncNumberPipe,
  ],
  providers: [
    FileService,
    UrlParamsService
  ]
};

@NgModule({
  imports: [
    common.modules,
    NgArrayPipesModule, NgStringPipesModule, NgNewlinesPipeModule,
    TranslateModule,
    NgSelectModule,
    MatProgressSpinnerModule,
    MatDialogModule
  ],
  declarations: [
    common.components,
    common.pipes,
    LoadingComponent,
    PickerDialogComponent,
    ImagesSelectableListComponent,
    DecoratedUploaderComponent,
    GoBackDirective
  ],
  exports: [
    common.modules,
    common.components,
    common.pipes,
    ImagesSelectableListComponent,
    DecoratedUploaderComponent,
    GoBackDirective
  ],
  providers: [
    common.providers
  ],
  entryComponents: [
    PickerDialogComponent
  ],
})
export class SharedModule { }
